<template>
  <el-container class="ListHeader" :class="{ 'ListHeader--withCenter': $slots.center }">
    <div class="ListHeader-results">
      <template v-if="total > 0">{{
        $t("components.lists.resultsFromTo", values)
      }}</template>
      <template v-else-if="!total">{{ $t("components.lists.noResult") }}</template>
      <template v-else>{{ $t("components.lists.loading") }}</template>
    </div>
    <div v-if="$slots.center" class="ListHeader-center">
      <slot name="center"></slot>
    </div>
    <div v-if="$slots.center" class="ListHeader-end">
      <div class="ListHeader-pagination">
        <el-pagination
          hide-on-single-page
          :layout="browserContext.down('md') ? 'prev, next' : 'prev, pager, next'"
          :total="total"
          :current-page="page"
          :page-size="limit"
          @current-change="pageChanged"
        ></el-pagination>
      </div>
      <div class="ListHeader-filters" v-if="total > 1 && browserContext.up('lg')">
        <slot></slot>
      </div>
    </div>
    <template v-else>
      <div class="ListHeader-pagination">
        <el-pagination
          hide-on-single-page
          :layout="browserContext.down('md') ? 'prev, next' : 'prev, pager, next'"
          :total="total"
          :current-page="page"
          :page-size="limit"
          @current-change="pageChanged"
        ></el-pagination>
      </div>
      <div class="ListHeader-filters" v-if="total > 1 && browserContext.up('lg')">
        <slot></slot>
      </div>
    </template>
  </el-container>
</template>

<script>
import { Pagination } from 'element-ui'

/**
 * Pagination incluse dans l'en-tête de liste
 */
export default {
  name: 'UbiListMeta',
  inject: ['browserContext'],
  components: {
    ElPagination: Pagination
  },
  props: {
    page: { type: Number, default: 1 },
    total: { type: Number, default: -1 },
    limit: { type: Number, default: 0 }
  },
  computed: {
    values () {
      const from = (this.page - 1) * this.limit + 1
      const to = Math.min(from + this.limit - 1, this.total)
      return {
        total: this.total,
        count: to - from + 1,
        from,
        to
      }
    }
  },
  methods: {
    pageChanged (newPage) {
      this.$emit('update:page', parseInt(newPage, 10))
      this.$emit('input')
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    limitChanged (newLimit) {
      this.$emit('update:limit', parseInt(newLimit, 10))
      this.$emit('input')
    }
  }
}
</script>

<style lang="scss">
@import "@/theme/_bootstrap.scss";

.ListHeader {
  align-items: center;
  justify-content: space-between;
  color: $black-variant;

  &-pagination .number {
    @extend .px-2, .font-secondary;
    font-size: $font-size-base-alt;
    font-weight: $font-weight-normal;
    min-width: initial;
  }

  &-results,
  &-filters {
    flex: 1;
    font-size: $font-size-base;
  }
  &-pagination {
    flex: 1;
    text-align: center;
  }
  &-filters {
    text-align: right;
  }

  &--withCenter#{&} {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);

    .ListHeader-pagination,
    .ListHeader-filters {
      flex: 0 0 auto;
    }
  }

  &-center {
    justify-self: center;
    text-align: center;
  }

  &-end {
    justify-self: end;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  @include media-breakpoint-down(md) {
    &-pagination {
      flex: 0;
    }
  }
}
</style>
